var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.75C16.9 25.75 16.81 25.73 16.71 25.69C16.43 25.58 16.25 25.3 16.25 25V19C16.25 18.59 16.59 18.25 17 18.25C17.41 18.25 17.75 18.59 17.75 19V23.19L18.47 22.47C18.76 22.18 19.24 22.18 19.53 22.47C19.82 22.76 19.82 23.24 19.53 23.53L17.53 25.53C17.39 25.67 17.19 25.75 17 25.75Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 25.75C16.8099 25.75 16.6199 25.68 16.4699 25.53L14.4699 23.53C14.1799 23.24 14.1799 22.76 14.4699 22.47C14.7599 22.18 15.2399 22.18 15.5299 22.47L17.5299 24.47C17.8199 24.76 17.8199 25.24 17.5299 25.53C17.3799 25.68 17.1899 25.75 16.9999 25.75Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30.75H17C11.57 30.75 9.25 28.43 9.25 23V17C9.25 11.57 11.57 9.25 17 9.25H22C22.41 9.25 22.75 9.59 22.75 10C22.75 10.41 22.41 10.75 22 10.75H17C12.39 10.75 10.75 12.39 10.75 17V23C10.75 27.61 12.39 29.25 17 29.25H23C27.61 29.25 29.25 27.61 29.25 23V18C29.25 17.59 29.59 17.25 30 17.25C30.41 17.25 30.75 17.59 30.75 18V23C30.75 28.43 28.43 30.75 23 30.75Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.75H26C22.58 18.75 21.25 17.42 21.25 14V9.99999C21.25 9.69999 21.43 9.41999 21.71 9.30999C21.99 9.18999 22.31 9.25999 22.53 9.46999L30.53 17.47C30.74 17.68 30.81 18.01 30.69 18.29C30.57 18.57 30.3 18.75 30 18.75ZM22.75 11.81V14C22.75 16.58 23.42 17.25 26 17.25H28.19L22.75 11.81Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.30c05b8f.svg";
export { ForwardRef as ReactComponent };